<template>
  <div class="flex min-h-dvh flex-col">
    <NuxtRouteAnnouncer />
    <div class="flex min-h-0 flex-1 flex-col">
      <NuxtPage />
    </div>
    <SiteFooter v-if="!route.meta.hideFooter" />
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
</script>
